import React, { useState, useCallback } from 'react';
import Image from '../Image/Image'
import RecycleBin from '../RecycleBin/RecycleBin'
import useFirestore from '../../hooks/useFirestore';
import { projectStorage, projectFirestore, timestamp } from "../../firebase/config";


import './DropZone.css';

const DropZone = ({ recycleBins, type, setSelectedImg, isSound, setIsSound }) => {
    const { docs } = useFirestore('images', type);
    const [isLoading, setIsLoading] = useState(false);
    const [isMessy, setIsMessy] = useState(true);


    const handleDrop = (index, item) => {
        // alert(`Index ${index} Item ${item.name}! Bin ${recycleBins[index]}`);

        setIsLoading(true)
        const collectionRef = projectFirestore.collection('images');
        collectionRef.doc(item.name).update({
            type: recycleBins[index].type
        }).then(() => {
            setIsLoading(false)
            console.log("Success")
        }
        ).catch((error) => {
            console.log(error)
        })


        return { ...recycleBins[index] }
    };

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
    }



    return (
        <div>
            {type === 'any' && <div className="options-space">
                <div className='options-container'>
                    <div>
                        <div className="options-title"> Chaotic </div>
                        <div className="options">
                            <a onClick={() => setIsMessy(true)} style={isMessy ? { color: '#fd3afd' } : { color: '' }}>YES</a>
                            <a onClick={() => setIsMessy(false)} style={!isMessy ? { color: '#fd3afd' } : { color: '' }}>NO</a> </div>
                    </div>
                    <div>
                        <div className="options-title"> Sound </div>
                        <div className="options">
                            <a onClick={() => setIsSound(true)} style={isSound ? { color: '#fd3afd' } : { color: '' }}>YES</a>
                            <a onClick={() => setIsSound(false)} style={!isSound ? { color: '#fd3afd' } : { color: '' }}>NO</a> </div>
                    </div>
                </div>
            </div>}
            <div className="recycle-space">
                {recycleBins.map(({ name, description, content }, index) => (
                    <RecycleBin name={name} content={content} description={description} key={index} onDrop={(item) => handleDrop(index, item)} isSound={isSound} />
                ))}
            </div>
            <div className="recycle-images-space">

                {!isLoading && docs && docs.map((doc, index) =>
                    <div>
                        <Image doc={doc} key={index} isLoading={isLoading} setSelectedImg={(doc) => setSelectedImg(doc)} isSound={isSound} type={type} x={(doc.type === 'any' && isMessy) ? getRandomInt(-150, 150) : 0} y={(doc.type === 'any' && isMessy) ? getRandomInt(-150, 150) : 0} />
                    </div>
                )}
            </div>
        </div >
    )
}

export default DropZone;